import './HalloweenAccents.css';

const sectionMotifs = Object.freeze({
  shop: ['pumpkin', 'web'],
  arena: ['web', 'bat'],
  collection: ['bat', 'web'],
  profile: ['web', 'pumpkin'],
  wallet: ['pumpkin', 'bat'],
  cases: ['web', 'pumpkin'],
  rating: ['bat', 'pumpkin'],
  metapass: ['pumpkin', 'web'],
  minigames: ['web', 'bat'],
  penalty: ['bat', 'web'],
  halloween: ['web', 'bat'],
  fishing: ['bat', 'pumpkin'],
  summer: ['web', 'pumpkin'],
  vabank: ['pumpkin', 'bat'],
  navigation: ['web', 'pumpkin'],
});

/** @param {{ kind: string, side: string }} props @returns {import('react').ReactNode} */
function HalloweenMotif({ kind, side }) {
  return <span className={`mc-halloween-motif is-${kind} is-${side}`}>
    {kind !== 'web' && <img src={`/assets/home-halloween/${kind === 'bat' ? 'bats' : kind}-v2.webp`} alt="" />}
    {kind === 'web' && <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth=".9">
      <path d="M1 1h61M1 1v61M1 1l58 28M1 1l44 44M1 1l28 58" />
      <path d="M16 1Q13 5 14 7Q10 8 11 11Q8 10 7 14Q5 13 1 16M31 1Q26 9 28 14Q21 17 22 22Q17 21 14 28Q9 26 1 31M46 1Q38 13 42 21Q31 25 33 33Q25 31 21 42Q13 38 1 46M61 1Q50 18 55 27Q42 33 44 44Q33 42 27 55Q18 50 1 61" />
    </svg>}
  </span>;
}

/** @param {{ variant: string }} props @returns {import('react').ReactNode} */
export function HalloweenPanelDecor({ variant }) {
  const motif = variant === 'minigames' || variant === 'universe' ? 'ghost' : variant === 'rating' || variant === 'stage' ? 'bat' : 'pumpkin';
  return <span className={`mc-halloween-panel-decor for-${variant}`} aria-hidden="true">
    <HalloweenMotif kind="web" side="right" />
    {variant !== 'card' && <HalloweenMotif kind={motif} side="left" />}
  </span>;
}

/** Decorative only: no layout space, interactive elements or accessible text.
 * @param {{ section: string }} props @returns {import('react').ReactNode}
 */
export function HalloweenAccents({ section }) {
  const motifs = sectionMotifs[section] ?? ['web', 'bat'];
  return <div className={`mc-halloween-accents${section === 'navigation' ? ' in-navigation' : ''}`}
    data-seasonal-section={section} aria-hidden="true">
    <HalloweenMotif kind={motifs[0]} side="left" />
    <HalloweenMotif kind={motifs[1]} side="right" />
  </div>;
}
